import { MonthlyEvaluationModalComponent } from 'src/app/pages/evaluation/monthly-evaluation-modal/monthly-evaluation-modal.component';
import { OneOffEvaluationModalComponent } from 'src/app/pages/evaluation/one-off-evaluation-modal/one-off-evaluation-modal.component';
import { WeeklyEvaluationStep1 } from 'src/app/pages/evaluation/weekly-evaluation/step1/step1.page';
import { NotificationBase } from './notification-base';

export class NotificationEvaluation extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  protected async viewNotification(): Promise<void> {
    console.log(this.item, 'Notification payload');
    // open dialog for evaluation type - 'monthly' | 'weekly | 'one-off'
    switch (this.item?.type) {
      case 'weekly':
        this.modalCtrl
          .create({
            component: WeeklyEvaluationStep1,
            componentProps: { assessmentId: this.item?.id },
          })
          .then((modal) => {
            // https://github.com/ionic-team/ionic-framework/issues/26872
            modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

            modal.present();
          });
        break;
      case 'monthly':
        this.modalCtrl
          .create({
            component: MonthlyEvaluationModalComponent,
            componentProps: { assessmentId: this.item?.id },
          })
          .then((modal) => {
            // https://github.com/ionic-team/ionic-framework/issues/26872
            modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

            modal.present();
          });
        break;
      case 'once_off':
        this.modalCtrl
          .create({
            component: OneOffEvaluationModalComponent,
            componentProps: { assessmentId: this.item?.id },
          })
          .then((modal) => {
            // https://github.com/ionic-team/ionic-framework/issues/26872
            modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

            modal.present();
          });
        break;

      default:
        break;
    }
  }
}
